module.exports = __webpack_public_path__ + "img/companies.092ce672.svg";